export default __webpack_public_path__ + "2c52429ad201532878975222cb28f57f.svg";